export default "__VITE_ASSET__BydFPVpR__"